import React from "react";
import { WORKSHOP_COPY, CHAOS_FAKTORY_URL } from "../../data/content";
import { Reveal } from "./primitives";

export const Workshops = () => (
  <section
    id="workshops"
    className="relative py-14 md:py-40 px-4 md:px-10 bg-[hsl(var(--accent))]"
    data-testid="workshops"
  >
    <div className="mx-auto max-w-[1600px] grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-[8vw] items-center">
      {/* Heading */}
      <Reveal>
        <span className="font-mono-c text-[10px] md:text-xs tracking-[0.28em] uppercase text-[#1a0906]">
          Workshops
        </span>
        <h2 className="font-display font-bold uppercase leading-[0.92] md:leading-[0.9] tracking-tight text-[#120504] mt-3 md:mt-5 text-[clamp(2rem,6.5vw,5.5rem)]">
          Training the next generation of screen action.
        </h2>
      </Reveal>

      {/* Body */}
      <Reveal delay={0.1} className="flex flex-col items-start">
        <p className="text-base sm:text-lg md:text-xl leading-relaxed text-[#1a0906] max-w-md">
          {WORKSHOP_COPY}
        </p>
        <a
          href={CHAOS_FAKTORY_URL}
          target="_blank"
          rel="noreferrer"
          className="w-full sm:w-auto inline-flex items-center justify-center gap-2 mt-6 md:mt-8 border border-[#120504] text-[#120504] px-7 py-3.5 font-mono-c text-xs tracking-[0.18em] uppercase hover:bg-[#120504] hover:text-[hsl(var(--accent))] active:scale-95 transition-all"
          data-testid="training-link"
        >
          Visit Chaos Faktory ↗
        </a>
        <small className="mt-4 md:mt-5 font-mono-c text-[10px] sm:text-[11px] tracking-[0.2em] uppercase text-[#3d1410]">
          Workshop programme coming soon.
        </small>
      </Reveal>
    </div>
  </section>
);
